export const DOCUMENTS_TYPES = {
    afs: 'afs',
    icr: 'icr',
    summary: 'summary'
};